import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './page-loader.style';

export const PageLoader: React.FC = () => (
  <Styled.Container>
    <Styled.IconContainer>
      <CircularProgress />
    </Styled.IconContainer>
  </Styled.Container>
);
